import { FC } from 'react';
import { Details } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { Tiltak } from '../../../../types/registration/tiltak';
import { TiltakCard } from '../../../expertRegistration/json/common/summary/tiltak';
import { StyledDetailsContent } from '../samtykke/form/components/styledComponents';

interface TiltakProps {
  tiltakList: Tiltak[];
}
export const TiltakView: FC<TiltakProps> = ({ tiltakList }) => {
  const { t } = useTranslation();

  if (!tiltakList || tiltakList.length === 0) {
    return null;
  }

  return (
    <Details>
      <Details.Summary>{t('tiltak.heading')}</Details.Summary>
      <StyledDetailsContent>
        <TiltakCard tiltakList={tiltakList} />
      </StyledDetailsContent>
    </Details>
  );
};
